import "whatwg-fetch"; // fetch polyfill for IE

import { playerUrl } from "./config";

const getAccountData = async accountCode => {
  const noCache = Math.round(new Date().getTime());
  const url = `${playerUrl}/account/GetAccountPlayer?code=${accountCode}&no-cache=${noCache}`;

  const data = await fetch(url);
  const json = await data.json();

  return json;
};

export default getAccountData;
